import TypeSelectView from "./TypeSelectView";
import C_ViewType from "../const/C_ViewType";
import C_PointerEvt from "../core/const/C_PointerEvt";


class TypeSelectViewLandscape extends TypeSelectView
{
    constructor()
    {
        super();
    }


    addPlayStyles()
    {
        this.roomTint = 0x00baff;
        this.roomOverTint = 0x60d3ff;

        let textSize = this.layout.relHeight(6);

        // normal view
        this.normViewBut = new PIXI.Container();

        let normBg = this.assets.getSprite("room_bg_gray");
        normBg.tint = 0x00baff;
        this.layout.propHeightScale(normBg, 45);
        this.normViewBut.addChild(normBg);

        let normBorder = this.assets.getSprite("room_bg_border_gray");
        normBorder.tint = 0x00baff;
        this.layout.propHeightScale(normBorder, 45);
        this.normViewBut.addChild(normBorder);

        let normTF = this.assets.getTF("Normal view", textSize, null, "#00baff");
        this.layout.horizontalAlignCenter(normTF, 0, normBg);
        this.layout.verticalAlignBottom(normTF, 10, normBg);
        this.normViewBut.addChild(normTF);

        let normShipCont = new PIXI.Container();
        this.normViewBut.addChild(normShipCont);

        let normShip3 = this.assets.getSprite("ship_3");
        this.layout.propHeightScale(normShip3, 20, normBg);
        this.layout.verticalAlignMiddle(normShip3, 0, normBg);
        this.layout.horizontalAlignCenter(normShip3, 0, normBg);
        normShipCont.addChild(normShip3);

        this.layout.horizontalAlignCenter(this.normViewBut, -20);
        this.layout.verticalAlignMiddle(this.normViewBut);
        this.addChild(this.normViewBut);
        this.normViewBut.interactive = true;
        this.normViewBut.on(C_PointerEvt.DOWN, this.onTypeSelected, this);
        this.normViewBut.on(C_PointerEvt.OVER, this.onTypeOver, this);
        this.normViewBut.on(C_PointerEvt.OUT, this.onTypeOver, this);
        this.normViewBut.viewType = C_ViewType.NORMAL;


        // top view
        this.topViewBut = new PIXI.Container();

        let topBg = this.assets.getSprite("room_bg_gray");
        topBg.tint = 0x00baff;
        this.layout.propHeightScale(topBg, 45);
        this.topViewBut.addChild(topBg);

        let topBorder = this.assets.getSprite("room_bg_border_gray");
        topBorder.tint = 0x00baff;
        this.layout.propHeightScale(topBorder, 45);
        this.topViewBut.addChild(topBorder);

        let topTF = this.assets.getTF("Top view", textSize, null, "#00baff");
        this.layout.horizontalAlignCenter(topTF, 0, topBg);
        this.layout.verticalAlignBottom(topTF, 10, topBg);
        this.topViewBut.addChild(topTF);

        let topShipCont = new PIXI.Container();
        this.topViewBut.addChild(topShipCont);

        let topShip3 = this.assets.getSprite("ship_3_top");
        this.layout.propHeightScale(topShip3, 26, topBg);
        this.layout.verticalAlignMiddle(topShip3, 0, topBg);
        this.layout.horizontalAlignCenter(topShip3, 0, topBg);
        topShipCont.addChild(topShip3);

        this.layout.horizontalAlignCenter(this.topViewBut, 20);
        this.layout.verticalAlignMiddle(this.topViewBut);
        this.addChild(this.topViewBut);
        this.topViewBut.interactive = true;
        this.topViewBut.on(C_PointerEvt.DOWN, this.onTypeSelected, this);
        this.topViewBut.on(C_PointerEvt.OVER, this.onTypeOver, this);
        this.topViewBut.on(C_PointerEvt.OUT, this.onTypeOver, this);
        this.topViewBut.viewType = C_ViewType.TOP;
    }
}

export default TypeSelectViewLandscape